<template>
  <div style="height: 100%;">
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;margin-bottom: 10px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>停车出场记录</span>
    </div>
    <div style="display: flex;flex-direction: column;align-items: center;text-align: center;">
      <div v-if="carList.length<1 || carList==null">
        <no-data style="margin-top: 35%"></no-data>
      </div>
      <vueSeamlessScroll :class-option="optionSetting" :data="carList" class="seamless-warp">
        <ul style="font-size: 13px;width: 290px;" v-for="(item,index) in carList" :key="index">
          <li>
            <span><img class="carIcon" src="../../../assets/images/basic_operations/menu/车辆.png" /></span>
            <span class="carNumFont">{{item.plate}}</span>
            <span class="carOut">出</span>
            <span class="carStatuIcon"><img
                src="../../../assets/images/basic_operations/menu/车辆出门.png" /></span>
            <span class="carTime">{{item.leaveTime}}</span>
          </li>
        </ul>
      </vueSeamlessScroll>
      <el-pagination style="padding-top: 27px;" v-if="paginaTionVlaue" :current-page="currentPage" :page-size="pageSize"
        :total="pageTotal" :small="true" @current-change="changePage" layout="prev, pager, next">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import vueSeamlessScroll from 'vue-seamless-scroll'
  import {getParkingLeaveRecord} from '../../../network/parking.js'
  import NoData from "@/components/NoData";
  export default {
    name: "CarAccessMonitoring",
    components: {
      NoData,vueSeamlessScroll
    },
    mounted() {
      // 判断如果分页只有一页  隐藏分页
      if (this.pageSize >= this.pageTotal) {
        this.paginaTionVlaue = false
      }
      this.getRecordList(this.parkingRecordParam.size)
      this.getRecordListInterval = setInterval(() => this.getRecordList(this.parkingRecordParam.size), 5000);
    },
    destroyed() {
      clearInterval(this.getRecordListInterval)
    },
    data() {
      return {
        //定时器名称
        getRecordListInterval: null,
        // 当前页
        currentPage: 1,
        // 总条数
        pageTotal: 12,
        // 每页条数
        pageSize: 12,
        // 如果只有一页时 隐藏分页
        paginaTionVlaue: true,
        // 定义车辆进出历史记录参数
        parkingRecordParam: {
          size: 12
        },
        // 车辆进出统计信息集合
        carList: []
      }
    },
    computed:{
      optionSetting(){
        return {
          step:1,//速度，值越大，速度越快
          hoverStop:true,//鼠标悬停效果，false为关闭该效果
          singleHeight: 50,//单行停顿
          waitTime: 3000,//单行停顿的时间
          openWatch: true, //开启数据实时监控刷新dom
        }
      }
    },
    methods: {
      // 页数切换
      //event数据源  page为当前页
      changePage(page) {
        this.currentPage = page;
      },
      // 车辆进出场历史记录整合
      async getRecordList(param) {
        await getParkingLeaveRecord(param).then(res => {
          // 轮询判断是否  值没有改变
          if (res.data != null) {
            if (res.data == this.carList) {
              return;
            } else {
              var list=res.data;
              this.carList = res.data;
              for (var i = 0; i < list.length; i++) {
                this.carList[i].leaveTime=list[i].leaveTime.substring(5,19)
              }
            }
          }
        })
      }
    }

  }
</script>

<style scoped>
  ul {
    padding: 0;
    margin: 3px;
    list-style: none;
  }

  ul li {
    border-bottom: 1px solid rgb(15, 54, 97);
  }

  /* 图片文字对齐 */
  .carStatu {
    padding-left: 30px;
    padding-right: 3px;
    vertical-align: middle;
  }

  .carStatuIcon {
    padding-right: 33px;
  }

  .carOut {
    width: 13px;
    height: 18px;
    font-size: 13px;
    font-weight: normal;
    line-height: 45px;
    color: #ECBB18;
    opacity: 1;
    vertical-align: middle;
    padding-right: 4px;
  }

  .carIn {
    width: 13px;
    height: 18px;
    font-size: 13px;
    font-weight: normal;
    line-height: 45px;
    color: #299BFF;
    opacity: 1;
    vertical-align: middle;
    padding-right: 4px;
  }

  .carIcon {
    width: 17px;
    height: 14px;
    opacity: 1;
    margin-right: 3px;
    margin-left: 5%;
  }

  .carNumFont {
    width: 90px;
    height: 18px;
    font-size: 13px;
    font-weight: normal;
    line-height: 45px;
    color: #FFFFFF;
    display: inline-block;
  }
  .seamless-warp{
    height: 250px;
    overflow: hidden;
  }
  .carTime {
    width: 94px;
    height: 18px;
    font-size: 13px;
    font-weight: normal;
    line-height: 45px;
    color: #D9DBE0;
    opacity: 1;
    vertical-align: middle;
  }
</style>
